// extracted by mini-css-extract-plugin
export default {"tableDistance":"NewDistanceTable_tableDistance__6xWym","formDiv":"NewDistanceTable_formDiv__GpVn0"};